import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "r247-marketing-screen",
  templateUrl: "./marketing-screen.component.html",
  styleUrls: ["./marketing-screen.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class R247MarketingScreenComponent {
  constructor(protected router: Router) {}

  goToRegister(selectedNumber) {
    return this.router.navigateByUrl(
      `/register/account?category=${selectedNumber.category}&prefix=${selectedNumber.prefix}&range=${selectedNumber.range}&number=${selectedNumber.number}`
    );
  }
}
